import React from 'react';
import { Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { truncateMiddle } from '../helpers/constant';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import WalletIconWithBadge from './wallet/WalletIconWithBadge';
import clsx from 'clsx';

const AddressCard = ({
    cardHeading = '',
    wallet = {},
    onClick,
    isAddCard = false,
    readOnly,
    className = '',
    savedAccounts,
}) => {
    const {
        nickName = '',
        address = '',
        cryptoId = null,
        beneficiaryName = '',
        accountNickName = '',
        currancyIcon = '',
        beneficiaryAccountNumber,
        sortCode,
        iban,
        swift,
    } = wallet;

    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();
  
    const truncateDesktopViewLength = windowWidth >= 1024 ? 20 : 10;
    const truncateMobViewLength = windowWidth >= 640 ? 20 : 10;

    const renderField = (label, value) =>
        value ? (
            <p className="!text-primary font-inter text-[12px] font-medium leading-[16px] uppercase">
                <span className="text-balanceCard-manage">{label}:</span>{' '}
                {truncateMiddle(value, truncateMobViewLength)}
            </p>
        ) : null;

    if (isAddCard) {
        return (
            <div
                onClick={readOnly ? null : onClick}
                className={clsx(
                    `h-[136px] flex flex-col items-center justify-center border-2 border-dashed self-stretch p-[.75rem] gap-[.75rem] rounded-md
                     border-gray-300 dark:border-[#70707B] bg-[#fafafa] dark:bg-[#FFFFFF0A] sm:p-4 md:p-5 cursor-pointer hover:border-gray-400 ${className}`,
                    readOnly && '!cursor-not-allowed',
                )}>
                <Add className="text-balanceCard-manage !w-8 !h-8" />
                <Typography className="font-semibold text-balanceCard-manage text-sm !font-inter">
                    {cardHeading}
                </Typography>
            </div>
        );
    }

    return (
        <div
            onClick={onClick}
            className={`flex flex-col justify-between items-start self-stretch !py-3.5 !px-3 rounded-md bg-card-bg ${savedAccounts ? 'h-[156px]' : 'h-[136px]'} cursor-pointer1`}>
            <WalletIconWithBadge
                currencyIcon={currancyIcon}
                cryptoId={cryptoId}
                height={10}
                width={10}
                iconDimension={26}
                imageDimension={5}
            />
            <div className="flex flex-col gap-1 mt-2">
                {savedAccounts ? (
                    <>
                        <p className="text-[10px] leading-[12px] font-medium uppercase text-gray-custom">
                            {truncateMiddle(
                                accountNickName || nickName,
                                truncateDesktopViewLength,
                            )}
                        </p>
                        <p className="text-sm text-buttons-tx-modal-bg font-semibold uppercase">
                            {truncateMiddle(
                                beneficiaryName || address,
                                truncateMobViewLength,
                            )}
                        </p>

                        {beneficiaryAccountNumber || sortCode ? (
                            <>
                                {renderField('Account Number', beneficiaryAccountNumber)}
                                {renderField('Sort Code', sortCode)}
                            </>
                        ) : (
                            <>
                                {renderField('IBAN', iban)}
                                {renderField('SWIFT', swift)}
                            </>
                        )}
                    </>
                ) : (
<>
                        <p className="text-sm font-semibold !text-primary truncate uppercase">
                            {truncateMiddle(nickName, truncateDesktopViewLength)}
                        </p>
                        <p className="text-xs text-balanceCard-manage font-medium uppercase">
                            {truncateMiddle(address, truncateMobViewLength)}
                        </p>
                    </>
                    )}
            </div>
        </div>
    );
};

export default AddressCard;
